import { Configuration, LogLevel } from "@azure/msal-browser";
import { CommonSilentFlowRequest } from "@azure/msal-common";

import EnvironmentConfiguration from "../../EnvironmentConfiguration";

/**
 * Configuration object to be passed to MSAL instance on creation.
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */

/** The configuration JSON object for setting up MSAL implementation. */
export const msalConfig: Configuration = {
  auth: {
    clientId: `${EnvironmentConfiguration.msal.applicationId}`, // This is the ONLY mandatory field that you need to supply.
    authority: `https://login.microsoftonline.com/${EnvironmentConfiguration.msal.tenantId}`,
    // You must register this URI on Azure Portal/App Registration.
    redirectUri: `${window.location.origin}/redirect.htm`,
    postLogoutRedirectUri: "/login", // Indicates the page to navigate after logout.
    navigateToLoginRequestUrl: false // If "true", will navigate back to the original request location before processing the auth code response.
  },
  cache: {
    cacheLocation: "sessionStorage", // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
    storeAuthStateInCookie: false // Set this to "true" if you are having issues on IE11 or Edge
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          // case LogLevel.Info:
          //   console.info(message);
          //   return;
          case LogLevel.Verbose:
            console.debug(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
        }
      }
    }
  }
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit:
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest: Partial<CommonSilentFlowRequest> = {
  forceRefresh: true,
  scopes: [`${EnvironmentConfiguration.msal.authenticationScope}`]
};
